import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export function SiteFooter() {
  return (
    <footer className="bg-[#010101] text-white border-t border-white/10" data-testid="site-footer">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div>
              <img src="/logo-kind.png" alt="KIND TECHNOLOGIES" className="h-12 w-auto mb-3" />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Distribuidor mayorista y proveedor de soporte certificado para México de AudioCodes y OneScreen.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-white">Enlaces</h4>
            <nav className="flex flex-col gap-2">
              {[{to:'/',l:'Inicio'},{to:'/nosotros',l:'Nosotros'},{to:'/servicios',l:'Servicios'},{to:'/clientes',l:'Clientes'},{to:'/contacto',l:'Contacto'}].map(i => (
                <Link key={i.to} to={i.to} className="text-sm text-gray-400 hover:text-white transition-colors duration-150">{i.l}</Link>
              ))}
              <a href="https://soporte.kindtechnologies.net/portal/es/home" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">Soporte</a>
            </nav>
          </div>

          {/* Store */}
          <div className="space-y-4">
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-white">Tienda</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/tienda" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">Catálogo</Link>
              <Link to="/login" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">Mi Cuenta</Link>
              <Link to="/terminos" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">Términos y Condiciones</Link>
              <Link to="/privacidad" className="text-sm text-gray-400 hover:text-white transition-colors duration-150">Aviso de Privacidad</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-white">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-sm text-gray-400">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>Presa Tepuxtepec No. 40-E, Col. Lomas Hermosa, Alcaldía Miguel Hidalgo, CP 11200 CDMX</span>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-400">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div className="space-y-1">
                  <div data-testid="footer-phone-tienda">
                    <span className="block text-xs uppercase tracking-wide text-gray-500">Atención de tienda</span>
                    <a href="tel:+525514541198" className="hover:text-white transition-colors">+52 55 1454 1198</a>
                  </div>
                  <div data-testid="footer-phone-mesa">
                    <span className="block text-xs uppercase tracking-wide text-gray-500">Mesa de ayuda</span>
                    <a href="tel:+525572526051" className="hover:text-white transition-colors">+52 55 7252 6051</a>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>info@kindtechnologies.net</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">&copy; {new Date().getFullYear()} Kind Technologies. Todos los derechos reservados.</p>
          <div className="flex gap-4">
            <Link to="/terminos" className="text-xs text-gray-500 hover:text-white transition-colors duration-150">Términos</Link>
            <Link to="/privacidad" className="text-xs text-gray-500 hover:text-white transition-colors duration-150">Privacidad</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
